<template>
  <div>
    <div class="style-container">
      <div class="px-3 mb-5 d-flex flex-column">
        <i class="bi bi-exclamation-circle style-icon"></i>
        <span>Oops! Something went wrong.</span>
      </div>
    </div>

    <!-- Homepage Button -->
    <div class="scss-button-position-bottom">
      <default-button title="Home" @click="goToHomepage" />
    </div>
  </div>
</template>

<script>
import DefaultButton from "@/components/button/DefaultButton.vue";
import { mapMutations } from "vuex";

export default {
  name: "GeneralErrorPage",
  components: { DefaultButton },
  methods: {
    goToHomepage() {
      this.$router.push("/home");
    },
    ...mapMutations(["showLoading"]),
  },
  created() {
    // Stop Loading spinner
    this.showLoading(false);
  },
};
</script>

<style lang="scss" scoped>
.style-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  min-height: 100vh;
}

.style-icon {
  color: #f23648;
  font-size: 70px;
}
</style>
